export const tripDTOFields = {
    id: 'id',
    journalId: 'journalId',
    name: 'name',
    date: 'date',
    description: 'description',
    childrenArray: 'childrenArray',
    sendConsentToParents: 'sendConsentToParents',
} as const;
